import { PARTICIPANT } from '../../../../User/Roles';

export default ({ user }) => user.role.type === PARTICIPANT;
